import React from 'react';
import { usePlanTabContentStyle } from './PlanDetailPanel.helpers';

export interface PlanNotesTabProps {
  notes?: string;
}

/** The Plans detail panel's "Notes" tab. */
const PlanNotesTab: React.FC<PlanNotesTabProps> = ({ notes }) => {
  const tabContentStyle = usePlanTabContentStyle();

  return (
    <div className="details-tab-container" style={tabContentStyle}>
      <div className="p-6" data-testid="plan-detail-tab-panel-notes">
        <div
          className="text-sm text-neutral-1000 whitespace-pre-wrap"
          style={{ paddingBottom: '48px' }}
        >
          {notes || 'No notes entered'}
        </div>
      </div>
    </div>
  );
};

export default PlanNotesTab;
